// SIP admin access bitmask — mirrors the SIPAdminAccess lookup table.
// Employees.SIPAdminAccessID is the sum of the granted bits; the login
// response carries it and AdminLogin stores it as admin_access_mask.
export const ACCESS = {
    INVENTORY: 1,
    MONTHLY_POINTS: 2,
    WELCOME_LETTERS: 4,
    QUAL_SUPERVISORS: 8,
    QUAL_EMPLOYEES: 16,
    ANNOUNCE_WINNERS: 32,
    LOAD_EMPLOYEES: 64,
    HISTORIC_REPORTS: 128,
    RIGHTS_MANAGEMENT: 256,
    ORDER_PROCESSING: 512,
    ANNUAL_SWAG: 1024,
};

export const ACCESS_LABELS = [
    { bit: ACCESS.INVENTORY,         label: 'Inventory' },
    { bit: ACCESS.MONTHLY_POINTS,    label: 'Monthly Points' },
    { bit: ACCESS.WELCOME_LETTERS,   label: 'Welcome Letter' },
    { bit: ACCESS.QUAL_SUPERVISORS,  label: 'Qual Maint — Supervisors' },
    { bit: ACCESS.QUAL_EMPLOYEES,    label: 'Qual Maint — Employees' },
    { bit: ACCESS.ANNOUNCE_WINNERS,  label: 'Announce Winners' },
    { bit: ACCESS.ORDER_PROCESSING,  label: 'Order Processing' },
    { bit: ACCESS.LOAD_EMPLOYEES,    label: 'Load Employees' },
    { bit: ACCESS.HISTORIC_REPORTS,  label: 'Historic Reports' },
    { bit: ACCESS.RIGHTS_MANAGEMENT, label: 'Rights Management' },
    { bit: ACCESS.ANNUAL_SWAG,       label: 'Annual Swag Admin' },
];

export const ALL_ACCESS = 2047; // all eleven bits

export function getAccessMask() {
    return Number(localStorage.getItem('admin_access_mask') || 0);
}

export function hasAccess(bit, mask = getAccessMask()) {
    return (mask & bit) !== 0;
}

// Route for each bit, in nav display order — used to pick the post-login
// landing page (first route the admin can actually see).
export const BIT_ROUTES = [
    { bit: ACCESS.MONTHLY_POINTS,    route: '/admin/disbursement' },
    { bit: ACCESS.WELCOME_LETTERS,   route: '/admin/welcome-letters' },
    { bit: ACCESS.INVENTORY,         route: '/admin/inventory' },
    { bit: ACCESS.QUAL_SUPERVISORS,  route: '/admin/supervisor-qual' },
    { bit: ACCESS.ANNOUNCE_WINNERS,  route: '/admin/winners' },
    { bit: ACCESS.QUAL_EMPLOYEES,    route: '/admin/employee-qual' },
    { bit: ACCESS.ORDER_PROCESSING,  route: '/admin/order-processing' },
    { bit: ACCESS.LOAD_EMPLOYEES,    route: '/admin/load-employees' },
    { bit: ACCESS.HISTORIC_REPORTS,  route: '/admin/reports' },
    { bit: ACCESS.RIGHTS_MANAGEMENT, route: '/admin/rights' },
    { bit: ACCESS.ANNUAL_SWAG,       route: '/admin/annual/program-year' },
];

export function firstAllowedRoute(mask = getAccessMask()) {
    const hit = BIT_ROUTES.find((r) => hasAccess(r.bit, mask));
    return hit ? hit.route : null;
}
